<template>

    <component :is="tag" class="font-mabry-pro font-bold heading" :class="classes">

        <slot/>

    </component>

</template>

<script lang="ts">

    import { defineComponent, computed } from 'vue'

    const headings: Record<string, string> = {
        h1: 'text-3xl-mo md:text-3xl',
        h2: 'text-2xl-mo md:text-2xl',
        h3: 'text-xl'
    }

    export default defineComponent({
        name: 'Header',
        props: {
            tag: { type: String, required: true },
            size: { type: String, required: false },
            noMargin: { type: Boolean, default: false },
            lessMargin: { type: Boolean, default: false },
            purple: { type: Boolean, default: false },
            pink: { type: Boolean, default: false }
        },
        setup(props) {

            return {
                classes: computed(() => {

                    return [
                        headings[props.size ?? props.tag],
                        {
                            '--no-margin': props.noMargin,
                            '--less-margin': props.lessMargin,
                            '--purple': props.purple,
                            '--pink': props.pink
                        }
                    ]

                })
            }

        }
    })

</script>

<style lang="scss">

    @include component(heading) {

        @include option(pink) {

            color: #FBA7F2 !important;
            transition: color 200ms ease-in;

            &:hover {

                color: #C000AF !important;

            }

        }

        @include option(purple) {

            color: #C000AF !important;

            @apply text-xl;

            @screen lg {

                font-size: 28px;
                line-height: 56px;

            }

        }

        + #{component(paragraph)} {

            @apply mt-12;

            @screen md {

                @apply mt-16;

            }

        }

        @include option(less-margin) {

            @screen md {

                + #{component(paragraph)} {

                    @apply mt-12;

                }

            }

        }

        @include option(no-margin) {

            + #{component(paragraph)} {

                margin-top: inherit;

            }

        }

    }

</style>
